import React, { useMemo } from 'react'
import Provider from './Provider'
import { ITalentPlaylistsViewProps, ITalentPlaylistsLinkerProps, IPlaylist } from './Interfaces'
import { Balloon } from 'components'
import { Typography, useMediaQuery, Box } from '@material-ui/core'
import useStyles from './Styles'
import { Corner } from 'components/balloon'
import { navigate } from '@reach/router'
import { theme } from 'config/constants/theme/theme'
import { EnterprisePlaylistPage } from 'smart-components/enterprise-playlist'

const TalentPlaylistsView: React.FC<ITalentPlaylistsViewProps> = ({ playlists, onClickPlaylist }) => {
  const classes = useStyles()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const balloonSize = downMd ? 270 : 235

  const itemsToRender = useMemo(() => {
    const BG_COLORS = ['#314DA1', '#F26723', '#2166A4', '#2166A4', '#413292', '#64CCE9', '#FDB72A']

    const CORNERS = [
      Corner.BottomLeft,
      Corner.TopLeft,
      Corner.TopRight,
      Corner.BottomRight,
      Corner.BottomLeft,
      Corner.TopLeft
    ]
    return playlists.map(item => {
      const coner = CORNERS.shift()
      const color = BG_COLORS.shift()

      CORNERS.push(coner)
      BG_COLORS.push(color)

      return {
        value: item,
        coner,
        color
      }
    })
  }, [playlists])

  const onBallonClick = (item: IPlaylist) => {
    onClickPlaylist
      ? onClickPlaylist(<EnterprisePlaylistPage enterpriseId={item.enterpriseId} playlistCode={item.playlistCode} />)
      : navigate(item.url)
  }

  return (
    <div className={classes.root}>
      <Typography id="talent-playlists-shared-with-you-label" variant="h4" className={classes.title}>
        Playlists shared with you
      </Typography>
      <div className={classes.playlistsContainer}>
        {itemsToRender.map((item, idx) => (
          <div className={classes.playlistItemWrapper} key={idx}>
            <Balloon
              style={{ cursor: 'pointer' }}
              corner={item.coner}
              bgColor={item.color}
              onClick={() => onBallonClick(item.value)}
              size={balloonSize}
            >
              <Box pt={5} px={4} className={classes.balloonContainer}>
                <Typography id="talent-playlists-playlist-name-label" className={classes.playlistName}>
                  {item.value.playlistName}
                </Typography>
              </Box>
            </Balloon>
          </div>
        ))}
      </div>
    </div>
  )
}

export default (props: ITalentPlaylistsLinkerProps) => (
  <Provider {...props}>{(viewProps: ITalentPlaylistsViewProps) => <TalentPlaylistsView {...viewProps} />}</Provider>
)
